module.exports = __webpack_public_path__ + "static/media/dice-five.9ddff2e3.svg";